import { Action, createFeature, createReducer, on } from '@ngrx/store';
import * as packageListingActions from '../actions';
import { produceOn } from '../../../../reducers/immer.helper';
import { error } from 'console';

export interface PackageListingsState {
  packages?: any[];
  pricingInfo?: any,
  totalCount?: number;
  isLoading?: boolean;
  error?: any;
}

export const initialState: PackageListingsState = {
  packages: [],
  pricingInfo: {},
  totalCount: 0,
  isLoading: false,
  error: null,
};

const PackageListingsReducer = createReducer(
  initialState,
  produceOn(packageListingActions.getAllPackageListings, (draft, result) => {
    draft.isLoading = true;
  }),
  produceOn(
    packageListingActions.getAllPackageListingsSuccess,
    (draft, result) => {
      draft.packages = result.data;
      draft.pricingInfo = result.pricingInfo,
      draft.totalCount = result.totalCount;
      draft.isLoading = false;
      draft.error = null;
    }
  ),
  produceOn(
    packageListingActions.getAllPackageListingsFailure,
    (draft, error) => {
      draft.isLoading = false;
      draft.error = error;
    }
  )
);

export function reducer(
  state: PackageListingsState | undefined,
  action: Action
): any {
  return PackageListingsReducer(state, action);
}
